<template>
  <section id="home" class="home">
    <!-- 六个整屏模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="{ 'is-visible': visibleMap[index] }"
    >
      <!-- 1920×1080 设计稿画布，等比缩放 -->
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <!-- 背景图不参与渐入 -->
        <img v-if="item.bgImage" :src="item.bgImage" class="section-bg" />
        <div class="section-inner">
          <!-- 上层图，选图见 overlaySrc -->
          <img
            v-for="overlay in item.overlays"
            :key="overlay.className"
            :src="overlaySrc(overlay)"
            class="section-img"
            :class="overlay.className"
          />
          <!-- 模块一小标语 -->
          <div v-if="item.key === 'hero'" class="hero-smallword">
            <span>{{ $t('home.smallword1') }}</span>
            <span class="smallword-divider">|</span>
            <span>{{ $t('home.smallword2') }}</span>
            <span class="smallword-divider">|</span>
            <span>{{ $t('home.smallword3') }}</span>
          </div>
          <!-- 模块一文字 -->
          <div v-if="item.key === 'hero'" class="hero-text">
            <h1 class="hero-title">{{ $t('home.heroTitle') }}</h1>
            <h2 class="hero-subtitle">{{ $t('home.heroSubtitle') }}</h2>
            <router-link to="/product" class="hero-btn">{{ $t('home.heroBtn') }} &gt;</router-link>
          </div>
          <!-- 模块二文字 -->
          <div v-if="item.key === 'daynight'" class="section-text">
            <h2 class="section-title">{{ $t('home.serviceTitle') }}</h2>
            <p class="section-desc">{{ mobileText($t('home.serviceDesc')) }}</p>
            <router-link to="/service" class="section-btn">{{ $t('home.serviceBtn') }}<span class="btn-arrow"></span></router-link>
          </div>
          <!-- 模块三文字 -->
          <div v-if="item.key === 'app'" class="app-text">
            <h2 class="app-title">{{ $t('home.missionTitle') }}</h2>
            <p class="app-desc">{{ mobileText($t('home.missionDesc')) }}</p>
          </div>
          <!-- 模块四文字 -->
          <div v-if="item.key === 'share'" class="share-text">
            <h2 class="share-main-title">{{ mobileText($t('home.shareTitle')) }}</h2>
            <div class="share-divider"></div>
            <div class="share-content">
              <h3 v-if="!isMobile" class="share-subtitle">{{ $t('home.shareSubtitle') }}</h3>
              <p class="share-desc">{{ mobileText($t('home.shareDesc')) }}</p>
            </div>
          </div>
          <!-- 模块五文字 -->
          <div v-if="item.key === 'mode'" class="mode-text">
            <h2 class="mode-title">{{ $t('home.modeTitle') }}</h2>
            <div class="mode-divider"></div>
            <p class="mode-desc">{{ mobileText($t('home.modeDesc')) }}</p>
          </div>
          <!-- 模块六文字 -->
          <div v-if="item.key === 'extra'" class="extra-text">
            <h2 class="extra-title">{{ $t('home.extraTitle') }}</h2>
            <div class="extra-divider"></div>
            <div class="extra-card">
              <h3 v-if="!isMobile" class="extra-card-title">{{ $t('home.extraCardTitle') }}</h3>
              <p class="extra-card-desc">{{ mobileText($t('home.extraCardDesc')) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        {
          key: 'hero',
          bgImage: require('@/assets/images/home/home-back@2x.png'),
          overlays: [
            { src: require('@/assets/images/home/home-1-cgm@2x.png'), srcEn: require('@/assets/images/home/home-1-INTcgm@2x.png'), className: 'section-overlay-hero' },
            { src: require('@/assets/images/home/home-1-small.png'), srcEn: require('@/assets/images/home/home-1-INTsmall.png'), className: 'section-overlay-hero-small' }
          ]
        },
        {
          key: 'daynight',
          overlays: [
            {
              src: require('@/assets/images/home/home-2-people.png'),
              srcEn: require('@/assets/images/home/home-2-INTpeople.png'),
              srcMobile: require('@/assets/images/home/home-2-phonepeople.png'),
              srcMobileEn: require('@/assets/images/home/home-2-INTphonepeople.png'),
              className: 'section-overlay-daynight'
            }
          ]
        },
        {
          key: 'app',
          overlays: [
            { src: require('@/assets/images/home/home-3-person.png'), srcMobile: require('@/assets/images/home/home-3-person-mobile.png'), className: 'section-overlay-app' },
            { src: require('@/assets/images/home/home-3-green.png'), className: 'section-overlay-app-green' }
          ]
        },
        {
          key: 'share',
          overlays: [
            { src: require('@/assets/images/home/home-4-people.png'), srcEn: require('@/assets/images/home/home-4-INTpeople.png'), srcMobile: require('@/assets/images/home/home-4-mobilepeople.png'), srcMobileEn: require('@/assets/images/home/home-4-mobileINTpeople.png'), className: 'section-overlay-share' }
          ]
        },
        {
          key: 'mode',
          overlays: [
            { src: require('@/assets/images/home/home-5-earth.png'), srcMobile: require('@/assets/images/home/home-5-mobileearth.png'), className: 'section-overlay-mode' }
          ]
        },
        {
          key: 'extra',
          overlays: [
            { src: require('@/assets/images/home/home-6-person.png'), srcMobile: require('@/assets/images/home/home-6-mobileperson.png'), className: 'section-overlay-extra-person' },
            { src: require('@/assets/images/home/home-6-green.png'), className: 'section-overlay-extra-green' },
            { src: require('@/assets/images/home/home-6-diamond.png'), className: 'section-overlay-extra-diamond' }
          ]
        }
      ],
      visibleMap: {},
      observer: null,
      isMobile: false,
      mobileQuery: null
    }
  },
  mounted() {
    // 记录初始缩放基准
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    // 断点监听（手机端文案去换行）
    this.mobileQuery = window.matchMedia('(max-width: 1024px)')
    this.isMobile = this.mobileQuery.matches
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.onMobileChange)
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(this.onMobileChange)
    }
    this.initObserver()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.mobileQuery) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMobileChange)
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMobileChange)
      }
    }
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    onMobileChange(e) {
      this.isMobile = e.matches
    },
    overlaySrc(overlay) {
      // 选图优先级：手机英文 srcMobileEn→srcEn→srcMobile→src；手机中文 srcMobile→src；桌面按语言 srcEn/src
      const isEn = this.$i18n.locale === 'en'
      if (this.isMobile) {
        return isEn
          ? (overlay.srcMobileEn || overlay.srcEn || overlay.srcMobile || overlay.src)
          : (overlay.srcMobile || overlay.src)
      }
      return isEn && overlay.srcEn ? overlay.srcEn : overlay.src
    },
    mobileText(text) {
      // \n 为桌面换行，| 为手机端换行
      return this.isMobile
        ? String(text).replace(/\n/g, '').replace(/\|/g, '\n')
        : String(text).replace(/\|/g, '')
    },
    updateScale() {
      // cover 模式：保证画布铺满窗口
      const fit = Math.max(window.innerWidth / 1920, window.innerHeight / 1080)
      // DPR 补偿浏览器缩放
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        // 不支持 IntersectionObserver 时直接全部显示
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    }
  }
}
</script>

<style scoped>
.home {
  background: #FFFFFF;
}

/* 整屏模块高度 */
.fullscreen-section {
  height: 100vh;
  /* 实时可见高度（JS 写入） */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
  background: #FFFFFF;
}

/* 模块二、四、六：灰底 */
.reveal-section:nth-child(2),
.reveal-section:nth-child(4),
.reveal-section:nth-child(6) {
  background: #F5F5F5;
}

/* 设计稿画布 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入：仅透明度，隐藏态不设过渡以便重播 */
  opacity: 0;
  will-change: opacity;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transition: opacity 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 背景图：铺满画布，不参与渐入 */
.section-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 上层图公共样式 */
.section-img {
  position: absolute;
  width: auto;
  height: auto;
  margin: auto;
}

/* 模块一：上层 CGM 图 */
.section-overlay-hero {
  max-width: 50%;
  max-height: 45%;
  top: 15%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 模块一：上层小图 */
.section-overlay-hero-small {
  max-width: 25%;
  max-height: 30%;
  top: 15%;
  left: 0;
  right: 35%;
  bottom: 0;
}

/* 英文版小图 */
:lang(en) .section-overlay-hero-small {
  max-width: 27%;
  max-height: 30%;
}

/* 模块二：上层人物图 */
.section-overlay-daynight {
  max-width: 70%;
  max-height: 90%;
  top: 10%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 英文版人物图 */
:lang(en) .section-overlay-daynight {
  max-width: 60%;
  max-height: 75%;
  top: 10%;
  left: 40%;
  right: 0;
  bottom: 0;
}

/* 模块三：上层插图 */
.section-overlay-app {
  max-width: 65%;
  max-height: 67%;
  top: 8%;
  left: 0;
  right: 50%;
  bottom: 0;
}

/* 模块三：青色色块卡片 */
.section-overlay-app-green {
  max-width: 47.4%;
  max-height: 60%;
  top: 8%;
  left: 52.55%;
  right: 0;
  bottom: 0;
}

/* 模块三：文字（青色卡片内垂直居中） */
.app-text {
  position: absolute;
  top: 8%;
  left: 62%;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.app-title {
  font-size: 50px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 30px 0;
  line-height: 1.4;
}

.app-desc {
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.8;
  white-space: pre-line;
}

/* 模块三动效拆分：标题与描述各自入场 */

/* 模块三：大标题入场 */
.reveal-section .app-text .app-title {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .app-text .app-title {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.5s ease 0.2s,
    transform 1.5s ease 0.2s;
}

/* 模块三：描述入场，晚于标题 */
.reveal-section .app-text .app-desc {
  opacity: 0;
  transform: translateY(24px);
}

.reveal-section.is-visible .app-text .app-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 模块三：人物图与青色卡片一起入场 */
.reveal-section .section-overlay-app,
.reveal-section .section-overlay-app-green {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .section-overlay-app,
.reveal-section.is-visible .section-overlay-app-green {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 模块四：上层人物图 */
.section-overlay-share {
  max-width: 50%;
  max-height: 50%;
  top: 20%;
  left: 30%;
  right: 0;
  bottom: 0;
}

/* 模块五：上层插图 */
.section-overlay-mode {
  max-width: 50%;
  max-height: 70%;
  top: 28%;
  left: 5%;
  right: 0;
  bottom: 0;
}

/* 模块六：人物图 */
.section-overlay-extra-person {
  max-width: 35%;
  max-height: 50%;
  top: 20%;
  left: 0;
  right: 35%;
  bottom: 0;
}

/* 模块六：绿色卡片图 */
.section-overlay-extra-green {
  max-width: 35%;
  max-height: 50%;
  top: 20%;
  left: 35%;
  right: 0;
  bottom: 0;
}

/* 模块六：钻石图标 */
.section-overlay-extra-diamond {
  max-width: 70px;
  max-height: 70px;
  top: 42%;
  left: 52.5%;
  z-index: 10;
}

/* 模块一：文字 */
.hero-text {
  position: absolute;
  top: 29%;
  left: 20%;
  z-index: 10;
}

.hero-title {
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 10px 0;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.5;
}

.hero-btn {
  display: inline-block;
  margin-top: 290px;
  padding: 14px 36px;
  background-color: #00ADBB;
  color: #FFFFFF;
  font-size: 30px;
  font-weight: 400;
  border-radius: 57px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.hero-btn:hover {
  background-color: #009999;
}

/* 模块一动效拆分：按钮与 CGM 图各自入场 */

/* 模块一：按钮入场，晚于文字 */
.reveal-section .hero-btn {
  opacity: 0;
  transform: translateY(24px);
  /* 隐藏态不设入场过渡 */
  transition: background-color 0.3s ease;
}

.reveal-section.is-visible .hero-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s,
    background-color 0.3s ease;   /* 悬停变色不延迟 */
}

/* 模块一：CGM 图入场，从小到大淡入 */
.reveal-section .section-overlay-hero {
  opacity: 0;
  transform: scale(0.8);
}

.reveal-section.is-visible .section-overlay-hero {
  opacity: 1;
  transform: scale(1);
  transition: opacity 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s,
    transform 1.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
}

/* 模块一：标题/副标题、小标语、图标小图统一入场 */
.reveal-section .hero-title,
.reveal-section .hero-subtitle,
.reveal-section .hero-smallword,
.reveal-section .section-overlay-hero-small {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .hero-title,
.reveal-section.is-visible .hero-subtitle,
.reveal-section.is-visible .hero-smallword,
.reveal-section.is-visible .section-overlay-hero-small {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 模块一：小标语文字 */
.hero-smallword {
  position: absolute;
  top: 0;
  left: 0;
  right: 37.5%;
  bottom: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 400;
  color: #868686;
  letter-spacing: 2px;
  white-space: nowrap;
  z-index: 11;
  /* 不拦截鼠标 */
  pointer-events: none;
}

.hero-smallword span {
  pointer-events: auto;
}

.smallword-divider {
  margin: 0 24px;
}

/* 英文版小标语字号与位置 */
:lang(en) .hero-smallword {
  font-size: 22px;
  right: calc(37.5% - 160px);
}

/* 英文版词间距 */
:lang(en) .smallword-divider {
  margin: 0 2px;
}

/* 模块二：文字 */
.section-text {
  position: absolute;
  top: 23%;
  left: 18%;
  z-index: 10;
  max-width: 45%;
}

.section-title {
  font-size: 50px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 40px 0;
  line-height: 1.3;
}

.section-desc {
  font-size: 24px;
  font-weight: 400;
  color: #868686;
  margin: 0 0 60px 0;
  line-height: 1.6;
  white-space: pre-line;
}

/* 英文版描述两端对齐 */
:lang(en) .section-desc {
  text-align: justify;
}

/* 英文版收窄文字容器 */
:lang(en) .section-text {
  max-width: 32%;
}

.section-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 28px;
  background-color: transparent;
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 400;
  border: 2px solid #252525;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

/* 箭头：横线 + 右上斜线（'>' 的上半部分） */
.btn-arrow {
  display: inline-block;
  top: 3px;
  width: 20px;
  height: 2px;
  background: currentColor;
  position: relative;
  vertical-align: middle;
}

.btn-arrow::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 12px;
  height: 2px;
  background: currentColor;
  transform-origin: right center;
  transform: rotate(40deg);
}

.section-btn:hover {
  background-color: #1a1a1a;
  color: #FFFFFF;
}

/* 模块二动效拆分：文字、人物图、按钮各自入场 */

/* 模块二：文字入场（与模块一统一：从下到上移动 30px） */
.reveal-section .section-text .section-title,
.reveal-section .section-text .section-desc {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .section-text .section-title,
.reveal-section.is-visible .section-text .section-desc {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 模块二：按钮入场，晚于文字（从下到上移动 30px） */
.reveal-section .section-btn {
  opacity: 0;
  transform: translateY(30px);
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}

.reveal-section.is-visible .section-btn {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.9s ease 0.4s,
    transform 0.9s ease 0.4s,
    background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;  /* 悬停变色不延迟 */
}

/* 模块二：人物图入场（从下到上移动 30px） */
.reveal-section .section-overlay-daynight {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .section-overlay-daynight {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 模块四：文字 */
.share-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.share-main-title {
  text-align: center;
  font-size: 42px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  padding-top: 12%;
  line-height: 0.1;
}

.share-divider {
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 50px auto 0;
}

.share-content {
  position: absolute;
  bottom: 20%;
  left: 22%;
  max-width: 34%;
  text-align: justify;
}

/* 英文版内容块宽度与位置 */
:lang(en) .share-content {
  max-width: 36%;              /* 收窄容器，避免盖到右侧人物图 */
  bottom: calc(20% - 80px);
}

.share-subtitle {
  font-size: 33px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.share-desc {
  font-size: 24px;
  font-weight: 400;
  color: #868686;
  margin: 0;
  line-height: 1.5;
  white-space: pre-line;
}

/* 英文版描述两端对齐 */
:lang(en) .share-desc {
  text-align: justify;
}

/* 模块四动效拆分：大标题、文字内容、人物图各自入场 */

/* 模块四：大标题入场（从下到上移动 30px） */
.reveal-section .share-text .share-main-title {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .share-text .share-main-title {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 模块四：文字入场 */
.reveal-section .share-text .share-content {
  opacity: 0;
  transform: translateY(40px);
}

.reveal-section.is-visible .share-text .share-content {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.5s ease 0s,
    transform 1.3s ease 0s;
}

/* 模块四：人物图入场 */
.reveal-section .section-overlay-share {
  opacity: 0;
  transform: translateX(80px);
}

.reveal-section.is-visible .section-overlay-share {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.5s ease 0s,
    transform 1.5s ease 0s;
}

/* 模块五：文字 */
.mode-text {
  position: absolute;
  top: 6%;
  left: 0;
  width: 100%;
  z-index: 10;
  text-align: center;
  padding-top: 8.5%;
}

.mode-title {
  font-size: 42px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 0.3;
}

.mode-divider {
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 40px auto 0;
}

.mode-desc {
  font-size: 20px;
  font-weight: 400;
  color: #868686;
  margin: 20px auto 0;
  max-width: 70%;
  line-height: 1.8;
  text-align: center;
  white-space: pre-line;
}

/* 英文版文字容器宽度 */
:lang(en) .mode-desc {
  font-size: 18px;
  max-width: 45%;
}


/* 模块五：文字整体入场（与全站统一：从下到上移动 30px） */
.reveal-section .mode-text {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .mode-text {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 模块五：地球图入场 */
.reveal-section .section-overlay-mode {
  opacity: 0;
  transform: translateY(120px);
}

.reveal-section.is-visible .section-overlay-mode {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.3s ease 0s,
    transform 1.5s ease 0s;
}

/* 模块六：文字 */
.extra-text {
  position: absolute;
  top: 6%;
  left: 0;
  width: 100%;
  z-index: 10;
  text-align: center;
  padding-top: 10%;
}

.extra-title {
  font-size: 46px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 0.3;
}

.extra-divider {
  width: 330px;
  height: 1px;
  background-color: #1a1a1a;
  margin: 40px auto 0;
}

.extra-card {
  position: absolute;
  top: 200%;
  left: 53%;
  max-width: 32%;
  text-align: left;
}

/* 英文版卡片容器宽度 */
:lang(en) .extra-card {
  max-width: 28%;
}

.extra-card-title {
  font-size: 38px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 18px 0;
  line-height: 1.4;
}

.extra-card-desc {
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0;
  line-height: 1.5;
  white-space: pre-line;
}

/* 英文版文字字号 */
:lang(en) .extra-title {
  font-size: 46px;
}

:lang(en) .extra-card-title {
  font-size: 40px;
}

:lang(en) .extra-card-desc {
  font-size: 24px;
}

/* 模块六动效拆分：大标题、左图、右图+卡片文字+钻石各自入场 */

/* 模块六：大标题入场（从下到上移动 30px） */
.reveal-section .extra-text .extra-title {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .extra-text .extra-title {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 模块六：左图入场 */
.reveal-section .section-overlay-extra-person {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section.is-visible .section-overlay-extra-person {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 模块六：右图组（绿卡+钻石+卡片文字）一起入场 */
.reveal-section .section-overlay-extra-green,
.reveal-section .section-overlay-extra-diamond {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section .extra-text .extra-card {
  opacity: 0;
  transform: translateY(80px);
}

.reveal-section.is-visible .section-overlay-extra-green,
.reveal-section.is-visible .section-overlay-extra-diamond {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

.reveal-section.is-visible .extra-text .extra-card {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 移动端 */
@media (max-width: 1024px) {
  /* 禁止 flex 压缩，避免 1px 分割线被压成 0 */
  .home .fullscreen-section .section-inner > *,
  .home .hero-text > *,
  .home .share-text > * {
    flex-shrink: 0;
  }

  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 模块一 */

  /* 内容容器改纵向文档流，子元素用 order 排序 */
  .home .fullscreen-section:nth-child(1) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 100px 0 3vh;
  }

  /* 打平文字容器，使子元素成为独立流式项 */
  .hero-text {
    display: contents;
  }

  /* 模块一间距统一用 vh，矮屏收紧、高屏拉开 */
  .hero-title {
    order: 1;
    font-size: 7.47vw;
    margin: 0 0 1vh 0;
    text-align: center;
  }

  :lang(en) .hero-title {
    font-size: 7.47vw;
  }

  .hero-subtitle {
    order: 2;
    font-size: 6.93vw;
    line-height: 1.4;
    margin: 0;
    text-align: center;
  }

  :lang(en) .hero-subtitle {
    font-size: 6.93vw;
  }

  /* CGM 大图 */
  .section-overlay-hero {
    order: 5;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 32vh;
    margin: 2vh 0 0 0;
  }

  .hero-btn {
    order: 6;
    font-size: 4.27vw;
    padding: 1.43vh 30vw;
    margin: 6vh 0 0 0;
  }

  :lang(en) .hero-btn {
    font-size: 4.27vw;
  }

  /* 小标语 */
  .hero-smallword {
    order: 3;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 2.57vh 14% 0;
    font-size: 3.6vw;
    letter-spacing: 0;
    white-space: normal;
    text-align: center;
  }

  :lang(en) .hero-smallword {
    font-size: 3.6vw;
  }

  /* 词间距 */
  .smallword-divider {
    margin: 0 4vw;
  }

  /* 上层小图 */
  .section-overlay-hero-small {
    order: 4;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 70%;
    max-height: 100vh;
    margin: 3vh 0 0 0;
  }

  :lang(en) .section-overlay-hero-small {
    max-width: 72%;
    max-height: 100vh;
    margin: 3vh 0 0 0;
  }

  /* 模块二 */

  .home .fullscreen-section:nth-child(2) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 76px 0 0;
  }

  .section-text {
    display: contents;
  }

  .section-title {
    order: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12%;
    text-align: center;
    font-size: 8vw;
    margin: 0 0 3vh 0;
  }

  :lang(en) .section-title {
    font-size: 8vw;
    padding: 0 8%;
  }

  .section-desc {
    order: 2;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12%;
    text-align: center;
    font-size: 4.27vw;
    margin: 0;
    white-space: normal;
  }

  :lang(en) .section-desc {
    font-size: 3.73vw;
    padding: 0 8%;
    text-align: justify;
  }

  /* 按钮浮在人物图下部 */
  .section-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4vh;
    width: max-content;
    margin: 0 auto;
    z-index: 10;
    font-size: 4.27vw;
    padding: 1.43vh 30vw;
    background-color: #1a1a1a;
    color: #FFFFFF;
    border-color: #1a1a1a;
    border-radius: 50px;
  }

  /* 箭头缩小 */
  .btn-arrow {
    width: 3.73vw;
    height: 0.2vh;
  }

  .btn-arrow::after {
    width: 2.2vw;
    height: 0.2vh;
  }

  /* 人物图贴底 */
  .section-overlay-daynight {
    order: 3;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: none;
    margin: auto 0 0 0;
  }

  :lang(en) .section-overlay-daynight {
    max-width: 90%;
    max-height: none;
  }

  /* 模块三 */
  .home .fullscreen-section:nth-child(3) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 88px 0 3vh;
  }

  /* 卡片文字块 */
  .app-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12%;
    text-align: center;
  }

  .app-title {
    font-size: 8vw;
    margin: 0 0 2vh 0;
    color: #1a1a1a;
  }

  .app-desc {
    font-size: 4.8vw;
    line-height: 1.7;
    color: #868686;
    white-space: pre-line;
  }

  :lang(en) .app-desc {
    padding: 0;
    font-size: 4.27vw;
  }

  /* 青色卡片：手机端隐藏 */
  .section-overlay-app-green {
    display: none;
  }

  /* 人物插图 */
  .section-overlay-app {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 80%;
    max-height: none;
    margin: 4vh 0 0 0;
  }

  /* 模块四 */

  .home .fullscreen-section:nth-child(4) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 86px 0 3vh;
  }

  /* 打平文字容器，使子元素成为独立流式项 */
  .share-text {
    display: contents;
  }

  .share-main-title {
    order: 1;
    font-size: 5.6vw;
    line-height: 1.5;
    margin: 0;
    padding: 0 8%;
    text-align: center;
    white-space: pre-line;
  }

  :lang(en) .share-main-title {
    font-size: 4.8vw;
    padding: 0;
    line-height: 1.5;
  }

  /* 分割线隐藏 */
  .share-divider {
    display: none;
  }

  /* 人物图 */
  .section-overlay-share {
    order: 4;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 80%;
    max-height: 42vh;
    margin: 2vh 0 0 0;
  }

  /* 人物图动效 */
  .reveal-section .section-overlay-share {
    opacity: 0;
    transform: translateY(6.86vh);
  }

  .reveal-section.is-visible .section-overlay-share {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.1s ease 0s,
      transform 1.1s ease 0s;
  }

  /* 内容块 */
  .share-content {
    order: 3;
    position: static;
    width: 100%;
    box-sizing: border-box;
    max-width: none;
    padding: 3vh 4% 0;
    text-align: center;
  }

  :lang(en) .share-content {
    padding: 0 4% 0;
    max-width: none;
  }

  .share-subtitle {
    font-size: 5.33vw;
    margin: 0 0 2vh 0;
  }

  :lang(en) .share-subtitle {
    font-size: 3.73vw;
  }

  .share-desc {
    font-size: 4.8vw;
    text-align: justify;
    white-space: normal;
  }

  :lang(en) .share-desc {
    font-size: 3.73vw;
    margin: 2.4vh 0 0 0;
    text-align: justify;
  }

  /* 模块五 */

  .home .fullscreen-section:nth-child(5) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding: 88px 0 3vh;
  }

  /* 文字块 */
  .mode-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  .mode-title {
    font-size: 7.47vw;
    line-height: 1.2;
    margin: 0;
  }

  :lang(en) .mode-title {
    font-size: 6.93vw;
    padding: 0 2%;
  }

  /* 分割线隐藏 */
  .mode-divider {
    display: none;
  }

  .mode-desc {
    font-size: 4vw;
    max-width: none;
    padding: 0 4%;
    margin: 3vh auto 0;
    box-sizing: border-box;
    white-space: normal;
    text-align: center;
  }

  :lang(en) .mode-desc {
    font-size: 4vw;
    line-height: 1.5;
    text-align: justify;
    max-width: none;
  }

  /* 地球图 */
  .section-overlay-mode {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 44vh;
    margin: 4vh 0 0 0;
  }

  /* 模块六 */

  /* 最后一屏精确一屏高，保证吸附点等距 */
  .home .fullscreen-section:nth-child(6) {
    height: var(--app-height, 100vh);
  }

  .home .fullscreen-section:nth-child(6) .section-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 88px 0 3vh;
  }

  .extra-text {
    order: 1;
    position: static;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }

  .extra-title {
    font-size: 6.93vw;
    line-height: 1.3;
    margin: 0;
  }

  :lang(en) .extra-title {
    font-size: 5.87vw;
    padding: 0 2%;
  }

  /* 分割线隐藏 */
  .extra-divider {
    display: none;
  }

  /* 绿色卡片与钻石隐藏 */
  .section-overlay-extra-green,
  .section-overlay-extra-diamond {
    display: none;
  }

  /* 卡片文字 */
  .extra-card {
    position: static;
    transform: none;
    width: 100%;
    box-sizing: border-box;
    max-width: none;
    margin: 4vh 0 0 0;
    padding: 0 12%;
    text-align: center;
  }

  :lang(en) .extra-card {
    max-width: none;
    margin: 2vh 0 0 0;
    padding: 0 8%;
  }

  /* 卡片入场动效 */
  .reveal-section .extra-text .extra-card {
    opacity: 0;
    transform: translateY(3.43vh);
  }

  .reveal-section.is-visible .extra-text .extra-card {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.1s ease 0s,
      transform 1.1s ease 0s;
  }

  .extra-card-title {
    font-size: 6.4vw;
    margin: 0 0 3vh 0;
    color: #1a1a1a;
  }

  .extra-card-desc {
    font-size: 4.53vw;
    color: #868686;
    white-space: normal;
    text-align: left;
  }

  :lang(en) .extra-card-desc {
    font-size: 4.27vw;
    text-align: justify;
  }

  /* 人物图 */
  .section-overlay-extra-person {
    order: 2;
    position: static;
    display: block;
    width: auto;
    height: auto;
    max-width: 70%;
    max-height: none;
    margin: 4vh 0 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner,
  .reveal-section .hero-btn,
  .reveal-section .section-overlay-hero,
  .reveal-section .hero-title,
  .reveal-section .hero-subtitle,
  .reveal-section .hero-smallword,
  .reveal-section .section-overlay-hero-small {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
